import { Link } from 'react-router-dom';

interface GarmentTagProps {
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  active?: boolean;
  holeColor?: string;
  className?: string;
}

export function GarmentTag({
  children,
  onClick,
  to,
  href,
  target,
  rel,
  active = false,
  holeColor = 'var(--color-champagne-light)',
  className = '',
}: GarmentTagProps) {
  const baseClasses = [
    'relative inline-flex items-center gap-2 pl-6 pr-4 py-2 rounded-md border text-sm font-medium whitespace-nowrap transition-colors duration-150',
    active
      ? 'bg-chocolate border-chocolate text-white shadow-sm'
      : 'bg-white border-champagne-dark text-text-medium hover:border-chocolate hover:text-chocolate',
    onClick || to || href ? 'cursor-pointer' : '',
    className,
  ].join(' ');

  const inner = (
    <>
      <span
        aria-hidden="true"
        className="absolute left-2 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full border border-current opacity-40"
        style={{ backgroundColor: holeColor }}
      />
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={baseClasses}>
        {inner}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={baseClasses}>
        {inner}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={baseClasses}>
        {inner}
      </button>
    );
  }

  return <div className={baseClasses}>{inner}</div>;
}
